var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"z-index":"3","color":"background","opacity":"1","absolute":""}},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}})])}
var staticRenderFns = []

export { render, staticRenderFns }